export function getCookie(name: string) {
  const nameEQ = `${name}=`;
  const cookies = document.cookie.split(';');
  for (let c of cookies) {
    while (c.startsWith(' ')) {
      c = c.slice(1);
    }
    if (c.startsWith(nameEQ)) {
      return decodeURIComponent(c.slice(nameEQ.length));
    }
  }
  return null;
}
